import { CompressedOrderShipmentGroup } from './compressed-order-shipment-group';
import { CompressedErrorMessage } from './compressed-error-message';
import { OrderShipmentGroupsList } from './order-shipment-groups-list';

export class CompressedOrderShipmentGroupsList {
  cacheProcessingTime?: Date;
  lastCacheProcessingTimeSeconds?: number;
  nextCacheProcessingStartedTime?: Date;
  lastCacheProcessingError?: string = null;
  missingContentRefreshTime?: Date = null;
  lastMissingContentRefreshError?: string = null;
  maxAllOrderShipments: number = 0;
  totalADEBSCount: number = 0;
  totalSGCCount: number = 0;
  allErrors: CompressedErrorMessage[];
  allCustomers: { [key: number]: string };
  allAccountExecutives: string[];
  allDrmTypes: string[];
  orderShipmentGroups: CompressedOrderShipmentGroup[];

  /**
   * Convert a CompressedOrderShipmentGroupsList to an OrderShipmentGroupsList for use in the rest of Insight.
   * @param compressedOrderShipmentGroupsList The CompressedOrderShipmentGroupsList.
   * @returns The OrderShipmentGroupsList.
   */
  static toOrderShipmentGroupsList(compressedOrderShipmentGroupsList: CompressedOrderShipmentGroupsList): OrderShipmentGroupsList {
    let orderShipmentGroupList = new OrderShipmentGroupsList();

    orderShipmentGroupList.cacheProcessingTime = compressedOrderShipmentGroupsList.cacheProcessingTime;
    orderShipmentGroupList.lastCacheProcessingTimeSeconds = compressedOrderShipmentGroupsList.lastCacheProcessingTimeSeconds;
    orderShipmentGroupList.nextCacheProcessingStartedTime = compressedOrderShipmentGroupsList.nextCacheProcessingStartedTime;
    orderShipmentGroupList.lastCacheProcessingError = compressedOrderShipmentGroupsList.lastCacheProcessingError;
    orderShipmentGroupList.missingContentRefreshTime = compressedOrderShipmentGroupsList.missingContentRefreshTime;
    orderShipmentGroupList.lastMissingContentRefreshError = compressedOrderShipmentGroupsList.lastMissingContentRefreshError;
    orderShipmentGroupList.maxAllOrderShipments = compressedOrderShipmentGroupsList.maxAllOrderShipments;
    orderShipmentGroupList.totalADEBSCount = compressedOrderShipmentGroupsList.totalADEBSCount;
    orderShipmentGroupList.totalSGCCount = compressedOrderShipmentGroupsList.totalSGCCount;
    orderShipmentGroupList.orderShipmentGroups = compressedOrderShipmentGroupsList.orderShipmentGroups
      .map((compressedGroup: CompressedOrderShipmentGroup) => CompressedOrderShipmentGroup.toOrderShipmentGroup(compressedOrderShipmentGroupsList, compressedGroup));

    return orderShipmentGroupList;
  }
}
